import { useQuery } from 'react-query';
import { getMutualFollowers, type MutualFollowers } from '../../services/userProfileFollows';

export function useGetMutualFollowers(options?: { enabled?: boolean }) {
  return useQuery<MutualFollowers, Error, MutualFollowers>(
    ['mutualFollowers'],
    getMutualFollowers,
    {
      enabled: options?.enabled ?? true,
      staleTime: 60 * 10 * 1000,
      cacheTime: 60 * 10 * 1000
    }
  );
}
